export default "__VITE_ASSET__COHA$d7e__"